<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
</script>
<script>
export default {
  name: "HomePage",
};
</script>

<template>
  <div>
    <el-divider></el-divider>
    <el-row :gutter="20" :align="middle">
      <el-col :span="18"><h1>OSS Korrekturen</h1></el-col>
      <el-col :span="6" style="display:flex; align-items: center; justify-content: center;"
        ><el-button
          type="primary"
          @click="router.push({ path: '/tools/oss-correction' })"
          >Start</el-button
        ></el-col
      >
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="20" :align="middle">
      <el-col :span="18"><h1>Bestätigungen von Vertrags-Daten</h1></el-col>
      <el-col :span="6" style="display:flex; align-items: center; justify-content: center;"
        ><el-button
          type="primary"
          @click="router.push({ path: '/tools/contract-data-confirmations' })"
          >Start</el-button
        ></el-col
      >
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="20" :align="middle">
      <el-col :span="18"><h1>Geschäftsvorgangsdaten</h1></el-col>
      <el-col :span="6" style="display:flex; align-items: center; justify-content: center;"
        ><el-button
          type="primary"
          @click="router.push({ path: '/tools/business-actions' })"
          >Start</el-button
        ></el-col
      >
    </el-row>
    <el-divider></el-divider>
  </div>
</template>

<style scoped lang="scss"></style>

<i18n>
  {
  "en-US": {
  }
  }
</i18n>
